import { App } from 'antd';
import { useCallback, useEffect } from 'react';
import { closeDrawer, useAppDispatch, useDrawer } from '../../../core';
import { FormUtils } from '../../merchants/utils/FormUtils';
import { CategoryForm } from '../components/CategoryForm';
import { useUpdateCategoryMutation } from '../store/category.api';

export const UpdateCategory = () => {
  const [
    updateCategory,
    { isSuccess: updateIsSuccess, reset: updateReset, error: updateErrors },
  ] = useUpdateCategoryMutation();
  const dispatch = useAppDispatch();
  const { notification } = App.useApp();
  const { resource } = useDrawer();

  const onFinish = useCallback(
    (attributes: any) => {
      const { icon, ...rest } = attributes;

      console.log(attributes);

      updateCategory({
        id: resource?.id,
        attributes: {
          ...rest,
          icon: FormUtils().getFileName(icon),
        },
      });
    },
    [updateCategory, resource],
  );

  useEffect(() => {
    if (!updateIsSuccess) {
      return;
    }

    dispatch(closeDrawer());
    updateReset();
  }, [dispatch, updateIsSuccess, updateReset]);

  useEffect(() => {
    if (!updateErrors) {
      return;
    }

    notification.error({
      message: 'Error',
      description: 'Please validate the form and try again.',
    });
  }, [notification, updateErrors]);

  return <CategoryForm onFinish={onFinish} isSubmitted={false} />;
};
